{
  "id": "campaign-029",
  "name": "Unkempt Park",
  "seed": "campaign:29",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,,,,,,,",
    ",b,,,,,,,,b,",
    ",,,,n,,n....",
    ",,,,,,,.....",
    ",...x,,.....",
    ".....,,,,...",
    ".....,,,,,..",
    "..,,,,,,,,,,",
    ",,,,,,,#,,,,",
    "____________",
    ",*,*,**,*,*,",
    ",,,,,,,...,,",
    ",T,,......T,",
    ",,,,.......,",
    ",,,,.......,",
    ",,,,,,,.....",
    ",,,,,,,,...S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 5
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 1
    }
  ],
  "generatorVersion": 3,
  "level": 29,
  "biome": "park",
  "par": {
    "reel": 16762,
    "push": 10144,
    "selfPropelled": 9744,
    "tractor": 5540,
    "zeroTurn": 6425,
    "fairway": 3868
  },
  "routeTries": {
    "par": {
      "reel": 10,
      "push": 0,
      "selfPropelled": 7,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 5
    }
  }
}
